type CertificatesTypeProps = {
  certificate_type: string;
  description?: string;
  title: string;
  token_id: string;
  offset_amount: string;
  projects: {
    [key: string]: string;
  };
};

import {
  sendQueryNFT,
  useQueryNftMetadata
} from 'lib/hooks/use-query-nft-metadata';
import GridTable from 'components/grid-table/grid-table';
import { columnsCertificates } from 'utils/columns-table';

import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';

import {
  StyledItemsEmpty,
  StyledEmptyText
} from 'components/grid-table/grid-table.style';

import { StyledHeading } from 'assets/styles/pages.style';

const CertificatesTable = () => {
  const accountId = useAppSelector(selectAccountId);

  const { tokens, isLoading, isLoadingMore, hasMore } = useQueryNftMetadata(accountId, sendQueryNFT);

  return (
    <>
      <StyledHeading>Certificates</StyledHeading>
      <GridTable<CertificatesTypeProps>
        uniqueKey="certificate"
        variant="certificate"
        loading={isLoading}
        columns={columnsCertificates}
        componentEmpty={
          <StyledItemsEmpty>
            <StyledEmptyText>No certificates</StyledEmptyText>
          </StyledItemsEmpty>
        }
        accountId={accountId}
        isLoading={isLoadingMore}
        hasMore={hasMore}
        data={tokens}
        defaultSort={{ key: 'issued_at', direction: 'descending' }}
      />
    </>
  );
};

export default CertificatesTable;
